import React from 'react'
import { TimeRangeInput } from './TimeRangeInput'

const DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

export function WeeklyHoursEditor({ weeklyHours, onChange, onSave, error, dirty = true }) {
  return (
    <div>
      <h4 className="dome-color-darkest-grey" style={{ marginBottom: 12 }}>
        Weekly Business Hours
      </h4>
      <p className="dome-p2 dome-color-med-grey" style={{ marginBottom: 16 }}>
        Override the default submission hours per day of the week.
      </p>
      <table className="table table-condensed">
        <thead>
          <tr>
            <th>Day</th>
            <th style={{ width: 80 }}>Closed</th>
            <th style={{ width: 300 }}>Hours</th>
          </tr>
        </thead>
        <tbody>
          {weeklyHours.map(({ opens_at, closes_at, day_of_week, closed }, index) => {
            return (
              <tr key={day_of_week}>
                <td
                  className="dome-p2 dome-color-darkest-grey"
                  style={{ textTransform: 'capitalize', verticalAlign: 'middle' }}
                >
                  {DAYS[day_of_week]}
                </td>
                <td style={{ verticalAlign: 'middle' }}>
                  <input
                    type="checkbox"
                    checked={!!closed}
                    onChange={(e) => onChange(day_of_week, { closed: e.target.checked })}
                  />
                </td>
                <td style={{ verticalAlign: 'middle' }}>
                  {!closed && (
                    <TimeRangeInput
                      open={opens_at}
                      close={closes_at}
                      onChange={({ open, close }) => onChange(day_of_week, { opens_at: open, closes_at: close })}
                    />
                  )}
                  {closed && <span className="dome-p2 dome-color-med-grey">closed</span>}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
      <div className="dome-d-flex dome-align-center dome-gap6">
        <button
          type="button"
          onClick={onSave}
          className={`dome-btn dome-btn-base ${dirty ? 'dome-btn-green-stroke' : 'dome-btn-disabled'}`}
          disabled={!dirty}
        >
          Save Weekly Hours
        </button>
        {error && <span className="text-danger dome-p3">{error}</span>}
      </div>
    </div>
  )
}
